<div mat-dialog-title>
  <div class="dialog-caption">TaxTank subscriptions are changing</div>

  <button mat-dialog-close class="btn icon-close" (click)="data.dialogRef.close()"></button>
</div>

<div mat-dialog-content>
  <div class="row">
    <div class="col-12 mb-15">
      We’re moving to a simpler, annual-only subscription model with automatic discounts based on how many Tanks
      you use. You only pay for what you need, and the more Tanks you choose, the more you save.
    </div>
    <div class="col-12">
      If you’re a current TaxTank subscriber on a monthly plan, nothing changes unless you choose to update
      or your subscription is cancelled.
    </div>
  </div>
</div>

<div mat-dialog-actions>
  <div class="row">
    <div class="col-auto">
      <button (click)="dialogRef.close()"
              type="button"
              class="btn primary">
        Continue
      </button>
    </div>
  </div>
</div>
